/* Search-page-only product card hydration.
   sections/main-search.liquid renders TWO card designs per product inside
   a [data-spc-card-slot] wrapper, each sitting inert inside a <template>
   (the browser doesn't upgrade custom elements, load <img> tags, or build
   a render tree for anything inside a <template> until JS clones it out).
   This script clones out only the ONE design the current viewport needs,
   so every product only ever pays for one card's worth of DOM/images/
   quick-add modals - not both at once. Runs on page load, again whenever
   facets.js swaps in a freshly filtered/sorted grid, and again if the
   viewport crosses the 768px breakpoint. */
(function () {
  var desktopQuery = window.matchMedia('(min-width: 768px)');

  function variantFor() {
    return desktopQuery.matches ? 'desktop' : 'mobile';
  }

  function hydrateSlot(slot) {
    var variant = variantFor();
    if (slot.dataset.hydratedVariant === variant) return;

    var template = slot.querySelector('template[data-variant="' + variant + '"]');
    if (!template) return;

    var previousLive = slot.querySelector(':scope > .spc-search-card-live');
    if (previousLive) previousLive.remove();

    var wrapper = document.createElement('div');
    wrapper.className = 'spc-search-card-live';
    wrapper.appendChild(template.content.cloneNode(true));
    slot.appendChild(wrapper);
    slot.dataset.hydratedVariant = variant;
  }

  function hydrateAll(root) {
    (root || document).querySelectorAll('[data-spc-card-slot]').forEach(hydrateSlot);
  }

  function init() {
    hydrateAll(document);

    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      var observer = new MutationObserver(function () {
        hydrateAll(grid);
      });
      // childList (not subtree) only fires for facets.js replacing the
      // grid's own children wholesale - not for our own hydration inserts
      // happening deeper inside each slot, which would otherwise re-trigger
      // this observer for every single card on every render.
      observer.observe(grid, { childList: true });
    }

    desktopQuery.addEventListener('change', function () {
      hydrateAll(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
